import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMoldReceivingFilters } from './store/selectors';
import { actions as maintenanceActions, fetchMoldReceivingWithFilters, fetchMoldMaintenanceWithStatus } from './store/slice';
import { Link } from 'react-router-dom';

const { setFromDate, setToDate, setStatus } = maintenanceActions;

const MoldMaintenanceFilter = () => {
  const dispatch = useDispatch();

  const { fromDate, toDate } = useSelector(selectMoldReceivingFilters);

  const onSearch = () => {
    dispatch(fetchMoldReceivingWithFilters());
  };
  const onStatusChange = (status) => {
      const numericStatus = Number(status);
      dispatch(setStatus(numericStatus));
      dispatch(fetchMoldMaintenanceWithStatus());
    };
  
    const statusOptions = [
      { value: 1, label: 'Active' },
      { value: 0, label: 'Released' },
    ];

  return (
    <div className="card visible" id="filter_inputs" style={{ display: 'block' }}>
      <div className="card-body pb-0">
        <div className="row">
          <div className="col-lg-2 col-md-3 col-sm-6 col-12">
            <div className="input-blocks">
              <label>
                From<span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={fromDate || ''}
                onChange={e => dispatch(setFromDate(e.target.value))}
                className="form-control"
                placeholder=""
              />
            </div>
          </div>
          <div className="col-lg-2 col-md-3 col-sm-6 col-12">
            <div className="input-blocks">
              <label>
                To <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                value={toDate || ''}
                onChange={e => dispatch(setToDate(e.target.value))}
                className="form-control"
                placeholder=""
              />
            </div>
          </div>

          <div className="col-lg-4 col-sm-6 col-12 align-content-end">
            <div className="input-blocks">
              <Link className="btn btn-filters" onClick={onSearch}>
                {' '}
                <i data-feather="search" className="feather-search" /> Search{' '}
              </Link>
            </div>
          </div>
           <div className="col-lg-2 col-md-3 col-sm-6 col-12 ms-auto">
            <div className="input-blocks">
              <label>Status</label>
              <select
                onChange={e => onStatusChange(e.target.value)}
                className="form-control"
              >
                {statusOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MoldMaintenanceFilter;
